import { ReviewSitesRequest, ReviewSitesResponse } from './../../entities/reviewSettings/ReviewSettingsResponse';
import { Endpoint } from '../endpoint';
import { ReviewResponse, ReviewId, CompactReviewResponse } from '@business/entities/review';
import { PageQuery, Paginate } from '@business/entities/common';
import { CompactReviewSettingsResponse, CompactReviewSettingsRequest } from '@business/entities/reviewSettings';
import { R } from '@core/utils/r';

export function fetchReviews(params: PageQuery) {
  return Endpoint.get<Paginate<ReviewResponse>>('@gc/reviews', { params: R.objectCompact(params) });
}

export function fetchReview(id: ReviewId) {
  return Endpoint.get<ReviewResponse>(`@gc/reviews/review/${id}`);
}

export function replyReview(id: ReviewId, data: { body: string }) {
  return Endpoint.post<ReviewResponse[]>(`@gc/reviews/reply/${id}`, { data });
}

export function getReviewSettings() {
  return Endpoint.get<CompactReviewSettingsResponse[]>(`@gc/reviews/settings`);
}

export function updateReviewSettings(data: { values: CompactReviewSettingsRequest[] }) {
  return Endpoint.post<CompactReviewSettingsResponse[]>(`@gc/reviews/settings`, { data });
}

export function getReviewSites() {
  return Endpoint.get<ReviewSitesResponse>(`@gc/reviews/sites`);
}

export function updateReviewSites(data: { values: ReviewSitesRequest }) {
  return Endpoint.post<CompactReviewSettingsResponse[]>(`@gc/reviews/sites`, { data });
}
